import React from "react";
import { Alert } from "@picklebet/ui";
import { LinkButton } from "@/features/shell/components/shared/LinkButton/LinkButton";
import { useStatusMessages } from "@/hooks/firestore/useStatusMessages";
import type { StatusMessage as StatusMessageModel } from "@/hooks/firestore/models/statusMessage";

import * as styles from "./StatusMessage.module.scss";

const tones = {
  INFO: { alert: "info", button: "info" },
  WARNING: { alert: "warning", button: "warning" },
  DANGER: { alert: "danger", button: "danger" },
  SUCCESS: { alert: "success", button: "primary" },
} as const satisfies Record<StatusMessageModel["type"], object>;

const StatusMessage = () => {
  const { statusMessages, isLoading } = useStatusMessages();

  if (isLoading || !statusMessages) {
    return null;
  }

  // grab latest status message out of the list as it is probably the most relevant one
  // ideally we never run more than 1 at the same time
  const statusMessage = statusMessages[statusMessages.length - 1];
  const tone = tones[statusMessage.type];

  return (
    <Alert
      color={tone.alert}
      size="default"
      className={styles.alert}
      isActionsInline
      actions={
        statusMessage.moreInfoUrl && (
          <LinkButton
            variant={tone.button}
            size="xxs"
            to={statusMessage.moreInfoUrl}
          >
            Learn More
          </LinkButton>
        )
      }
    >
      {statusMessage.description}
    </Alert>
  );
};

export { StatusMessage };
